const getEnv = () => {
  if (typeof window !== 'undefined') return window.__ENV__ || {}

  return process.env
}

module.exports = { getEnv }
